import { render } from "./ViewDocument.vue?vue&type=template&id=320efaca&scoped=true&ts=true"
import script from "./ViewDocument.vue?vue&type=script&lang=ts"
export * from "./ViewDocument.vue?vue&type=script&lang=ts"

import "./ViewDocument.vue?vue&type=style&index=0&id=320efaca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320efaca"]])

export default __exports__